import { Entity } from "../../Entity";
import LocaleFactory from "../../Factories/LocaleFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { LocaleInterface } from "./LocaleInterface";

class Locale extends Entity implements LocaleInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return LocaleFactory;
  }

  get iso(): string {
    return this.data.iso;
  }
}

export { Locale }
